var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLineChart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29688 2.64844V18.6484H18.2969M6.29688 12.6485L9.79688 9.14854L12.2969 11.6485L17.7969 6.14854M14.055 5.64844H18.2976V9.89108",
    stroke: "#5579F0",
    strokeWidth: 1.67467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLineChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LineChart.0df8f135.svg";
export { ForwardRef as ReactComponent };